exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".bg-color-primary {\n    background: #b6d5f5\n}\n\n.bg-light-blue {\n    background: rgb(94, 187, 241)\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// P:/Portfolio-angular-master/src/app/top/top-view/top-view.component.css
// module id = ../../../../../src/app/top/top-view/top-view.component.css
// module chunks = main